





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Ax } from '@/utils';

@Component({
    name: 'c-budget-program-info'
})
export default class CBudgetProgramInfo extends Vue {

    @Prop({
        required: true
    })
    private title!: string;

    @Prop({
        required: true
    })
    private infoId!: number;

    @Prop({
        required: true
    })
    private fileName!: string;

    @Prop({
        required: false,
        default: () => []
    })
    private infoTextLines!: string[];

    @Prop({
        required: false,
        default: null
    })
    private videoUrl!: string | null;

    private infoCostForm(infoId: number) {
        Ax(
            {
                url: '/api-py/get-info/' + infoId, //  Тело файла
                method: 'POST',
                data: null,
                responseType: 'blob'
            },
            (data: any) => {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.fileName + '.pdf');// or any other extension
                document.body.appendChild(link);
                link.click();
            },
            (error) => {
                this.makeToast('danger', this.$t('modules.budget_request.budget_programs.info.guide_error'), error.toString());
            }
        );
    }

    private openVideoOnNewTab() {
        if (this.videoUrl) {
            window.open(this.videoUrl);
        }
    }

    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
}
